import { ToastContainer } from "@/components/ui/Toast";
import { useToastStore } from "@/stores/useToastStore";

type GlobalToastContainerProps = React.HTMLAttributes<HTMLDivElement>;

export const GlobalToastContainer = ({ className }: GlobalToastContainerProps) => {
  const toasts = useToastStore((state) => state.toasts);
  const dismissToast = useToastStore((state) => state.dismissToast);

  return (
    <ToastContainer
      toasts={toasts}
      onDismiss={dismissToast}
      showCloseButton
      className={className}
    />
  );
};
